module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[51]172.5d72ce7.woff2";